// ============================================================================
// atendidosRegua: "clientes atendidos" = comanda com serviço (23/10/2026,
// rodada 2, item 3; decisão do dono). Puro: sem rede, sem React, sem imports.
// ============================================================================
// Régua: o 0089 (comandas SERVICO + PRODUTO/SERVICO) no mês aberto e as comandas
// únicas (data + número) do 0031 no fechamento (scripts/avec-daily-sync.mjs) dão o
// mesmo número (0 a 4 de diferença por unidade no mês: compra de pacote sem serviço).
// O 0002 não entra mais no lugar do 0089: ele deixa de fora clientes antigos
// inteiros (5% a 26% a menos, diferente em cada unidade).
// Usado por src/services/avecSync.js (coleta ao vivo) e pelo
// scripts/rebuild-avec-snapshots.mjs (meses fechados).
// ============================================================================

// Comandas com serviço no 0031 item a item (paginado). null quando não dá para
// confiar na contagem: lista ausente, possivelmente cortada pelo teto de páginas,
// linha sem data ou sem número, ou lista vazia sem o total do 0031 confirmar zero.
// servicosNoTotal (o total de serviços que o próprio 0031 informa para o período
// inteiro): a lista só vale se tiver pelo menos esses serviços. Lista com menos
// linhas que o total está faltando página (o "hasMore" ausente vira false e a
// coleta para na 1ª página), então a contagem dela seria parcial: null.
// Cada linha conta 1 serviço (ou a quantidade dela, se maior).
export function contarComandasComServico(linhas, { maxLinhas = Infinity, zeroConfirmado = false, servicosNoTotal } = {}) {
  if (!Array.isArray(linhas)) return null;
  if (linhas.length === 0) return zeroConfirmado ? 0 : null;
  if (linhas.length >= maxLinhas) return null;
  const comandas = new Set();
  let servicos = 0;
  for (const it of linhas) {
    const data = it?.data, numero = it?.numero;
    if (data == null || data === '' || numero == null || numero === '') return null;
    comandas.add(`${data}|${numero}`);
    const q = Number(it?.quantidade);
    servicos += Number.isFinite(q) && q > 1 ? q : 1;
  }
  if (servicosNoTotal !== undefined) {
    const total = Number(servicosNoTotal);
    if (!Number.isFinite(total) || total <= 0 || servicos < total) return null;
  }
  return comandas.size;
}

/**
 * Escolhe os atendidos da coleta. Entradas (estado já conferido pela coleta):
 *   ok0089 / atend0089: o 0089 respondeu (e não foi marcado incoerente) e o total
 *     SERVICO + PRODUTO/SERVICO;
 *   ok0031 / qtd0031: o 0031 de página única respondeu e a quantidade de serviços;
 *   ok0031p / linhas0031p / maxLinhas0031p: o 0031 paginado (só quando pedido).
 * Saída: { visitas: número | null, fonte: '0089' | '0031p' | null }.
 *   - 0089 com atendimento → 0089;
 *   - 0089 zerado e o 0031 também zerado → 0 (nenhum serviço no período, pelos dois);
 *   - senão as comandas únicas do 0031 paginado, quando confiáveis: o 0031 de página
 *     única respondeu e a lista tem todos os serviços que o total dele informa
 *     (sem o total não dá para saber se a lista veio inteira);
 *   - senão sem dado (null). Nunca o 0002.
 */
export function escolherAtendidos({ ok0089, atend0089, ok0031, qtd0031, ok0031p, linhas0031p, maxLinhas0031p = Infinity } = {}) {
  const a = Number(atend0089) || 0;
  const zero0031 = !!ok0031 && (Number(qtd0031) || 0) === 0;
  if (ok0089 && a > 0) return { visitas: a, fonte: '0089' };
  if (ok0089 && zero0031) return { visitas: 0, fonte: '0089' };
  if (ok0031p && ok0031) {
    const n = contarComandasComServico(linhas0031p, { maxLinhas: maxLinhas0031p, zeroConfirmado: zero0031, servicosNoTotal: Number(qtd0031) || 0 });
    if (n != null) return { visitas: n, fonte: '0031p' };
  }
  return { visitas: null, fonte: null };
}
